import React from "react";
import PropTypes from "prop-types";

const Square = ({ className, color }) => {
  return (
    <svg className={className} viewBox="0 0 15.5 15.5">
      <g>
        <rect
          x="0.25"
          y="0.25"
          width="15"
          height="15"
          fill="none"
          stroke={color}
          strokeWidth={0.5}
        />
      </g>
    </svg>
  );
};

Square.defaultProps = {
  className: ``,
  color: `#231f20`
};

Square.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default Square;
